import React from 'react';
import { ModalsConsumer, ModalsProvider } from '../Modal/ModalsProvider';
import SignInForm from '../Form/SignInForm';
import SignUpForm from '../Form/SignUpForm';

import Icon from '../Icon/Icon';
import profileIcon from '../../images/profile.svg';
import profileWhiteIcon from '../../images/profile-white.svg';
import logoutIcon from '../../images/logout.svg';
import signUpIcon from '../../images/sign-up.svg';
import coinIcon from '../../images/coin.svg';

class Profile extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    renderUser() {
        return (
            <div className='profile profile--user'>
                <span className='profile__user profile__row'>
                    <span className='profile__icon'>
                        <Icon glyph={profileWhiteIcon} />
                    </span>

                    <span>{app.user.username}</span>

                    <a href='/user/logout' className='profile__logout'>
                        <Icon glyph={logoutIcon} />
                    </a>
                </span>

                <span className='profile__balance profile__row'>
                    <span className='profile__icon'>
                        <Icon glyph={coinIcon} />
                    </span>

                    <span>{app.user.balance} REX</span>

                    <span>на счету</span>
                </span>
            </div>
        );
    }

    renderGuest() {
        return (
            <ModalsConsumer>
                {({ showModal }) => (
                    <div className='profile profile--guest'>
                        <a
                            className='profile__row profile__sign-in'
                            onClick={() => showModal(<SignInForm />)}
                        >
                            <span className='profile__icon'>
                                <Icon glyph={profileIcon} />
                            </span>
                            Войти
                        </a>
                        <a
                            className='profile__row profile__sign-up'
                            onClick={() => showModal(<SignUpForm />)}
                        >
                            <span className='profile__icon'>
                                <Icon glyph={signUpIcon} />
                            </span>
                            Регистрация
                        </a>
                    </div>
                )}
            </ModalsConsumer>
        );
    }

    render() {
        return (
            <ModalsProvider>
                {app.user.username ? this.renderUser() : this.renderGuest()}
            </ModalsProvider>
        );
    }
}

export default Profile;



// WEBPACK FOOTER //
// ./components/Profile/Profile.jsx